import { useTranslation } from 'react-i18next';
import { FaArrowsRotate, FaWifi } from 'react-icons/fa6';
import { useApiError } from '../../contexts/apiError';
import queryClient from '../../utils/queryClient';
import './ErrorPage.scss';

/**
 * ApiUnavailablePage - Displayed when the backend API is unreachable
 *
 * Shows when network errors occur (API completely unreachable).
 * Provides retry and reload buttons.
 */
const ApiUnavailablePage = () => {
  const { t } = useTranslation();
  const { clearError } = useApiError();

  const handleRetry = async () => {
    // Clear the error state
    clearError();
    // Invalidate all queries to retry them
    await queryClient.invalidateQueries();
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="error-page">
      <div className="error-page-content">
        <div className="error-icon">
          <FaWifi size={64} />
        </div>

        <h1 className="error-title">
          {t('error.api.network_title')}
        </h1>

        <p className="error-message">
          {t('error.api.network_message')}
        </p>

        <div className="error-actions">
          <button
            className="button is-primary"
            onClick={handleRetry}
          >
            <span className="icon">
              <FaArrowsRotate />
            </span>
            <span>{t('error.api.retry')}</span>
          </button>

          <button
            className="button"
            onClick={handleReload}
          >
            <span className="icon">
              <FaArrowsRotate />
            </span>
            <span>{t('error.api.reload')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiUnavailablePage;
